module.exports = __webpack_public_path__ + "static/media/Slider 1 4.b4e6d4df.jpg";